import { IStoreState } from '../types';

export const getCountriesList = ({ countries }: IStoreState) => countries.items;
